import { ADD_PAYLOAD, DELETE_PAYLOAD, EDIT_PAYLOAD, EDIT_PAYLOAD_FAMILYGROUP, EDIT_PAYLOAD_VOLUMETRICS, EMPTY_PAYLOAD_FAMILYGROUP, SEARCH_PAYLOAD, SAVE_RESPONSE } from '../Types/types'
import { iInitialStateDuType } from "../../Interfaces/IDuType";
import { iInitialStateFamilyGroup } from "../../Interfaces/IFamilyGroup";

export interface initialState {
  data: null,
  saveStatus?: { status: "success" | "error"; message?: string } | null,
};

const defaultState: initialState = { data: null, saveStatus: null };

function popupReducer(state: initialState = defaultState, action: any) {
  switch (action.type) {
    case ADD_PAYLOAD:
      return {
        ...state,
        data: action.payload,
      }
    case EDIT_PAYLOAD:
      return {
        ...iInitialStateDuType,
        data: action.payload,
        saveStatus: null,
      }
    case SEARCH_PAYLOAD:
      return {
        ...iInitialStateDuType,
        data: action.payload,
      }
    case EDIT_PAYLOAD_FAMILYGROUP:
      return {
        ...iInitialStateFamilyGroup,
        data: action.payload,
        saveStatus: null,
      }
    case EDIT_PAYLOAD_VOLUMETRICS:
      return {
        data: action.payload,
        saveStatus: null,
      }
    case EMPTY_PAYLOAD_FAMILYGROUP:
      return {
        data: null
      }
    case DELETE_PAYLOAD:
      return {
        ...state,
        data: action.payload,
      }
    case SAVE_RESPONSE:
      return {
        ...state,
        saveStatus: action.payload,
      }
    default:
      return state
  }
}

export default popupReducer;
